import { FinanceTermLookup, Lookup } from "../models/Configuration";
import { ApiFactory } from "./ApiFactory";
import agent from "./agent";

export default class LookupManagementApi {

    private apiFactory: ApiFactory;
    constructor(apiFactory: ApiFactory) {
      this.apiFactory = apiFactory;
    }

    getLookups = async () => {
        try {
          const response = await agent.api.get("/lookupmanagement", null);
          return response;
        } 
        catch (error) {
          throw error;
        }
      };

    saveFreightMethod = async (formData: Lookup) => {
        try {
          const response = await agent.api.post(`/lookupmanagement/savefreightmethod`,  formData);
          return response;
        } 
        catch (error) {
          throw error;
        }
    }

    saveFinanceTerm = async (formData: FinanceTermLookup) => {
        try {
          const response = await agent.api.post( `/lookupmanagement/savefinanceterm`,formData );
          return response;
        } 
        catch (error) {
          throw error;
        }
    }

    saveDeliveryMethod = async (formData: Lookup) => {
        try {
          const response = await agent.api.post(`/lookupmanagement/savedeliverymethod`,formData);
          return response;
        } 
        catch (error) {
          throw error;
        }
    }

}